export type IForceUniqueSelectValues = (form: HTMLFormElement | JQuery<HTMLFormElement>) => void;

export function forceUniqueSelectValues(form: HTMLFormElement | JQuery<HTMLFormElement>): void {
  const $form = $(form);
  const $forceUniqueSelects = $form.find('select.force-unique-value');

  function getTakenValuesArray($groupedSelects: JQuery<HTMLSelectElement>) {
    // Get array of taken values
    const takenValues: string[] = [];
    $groupedSelects.each((_, select) => {
      const $selectedOption = $(select).find('option:selected');
      if ($selectedOption.val()) {
        takenValues.push($selectedOption.val() as string);
      }
    });
    return takenValues;
  }

  function updateSelectOptions($groupedSelects: JQuery<HTMLSelectElement>, takenValues: string[]) {
    // Updated options
    $groupedSelects.each((_, select) => {
      const $select = $(select);
      const currentValue = $select.find('option:selected').val() as string;
      const availableOptions = $select.data('options');
      const newOptions = availableOptions.filter((opt: HTMLOptionElement) => {
        const optValue = $(opt).val() as string;
        let valueIsAllowed = false;
        if (currentValue === optValue || takenValues.indexOf(optValue) === -1) {
          valueIsAllowed = true;
        }
        return valueIsAllowed;
      });
      $select.empty().append(newOptions).val(currentValue);
    });
  }

  function makeSelectValuesUnique($select: JQuery<HTMLSelectElement>) {
    const $groupedSelects = $select.closest('form').find($select.data('select-group-selector'));
    const takenValues = getTakenValuesArray($groupedSelects);
    updateSelectOptions($groupedSelects, takenValues);
  }

  // Bind change event to unique selects
  $forceUniqueSelects.each((_, select) => {
    const $select = $(select);
    const opsArr: JQuery<HTMLOptionElement>[] = [];
    // Save copy of all options in select data-options
    ($select as any).find('option').each((__: number, option: HTMLOptionElement) => {
      opsArr.push($(option));
    });
    $select.data('options', opsArr);
    $(select).on('change', (e) => makeSelectValuesUnique($(e.currentTarget) as any));
  });
  makeSelectValuesUnique($forceUniqueSelects.last() as any);
}
